export const VOICE_LIST_REQUESTED = "VOICE_LIST_REQUESTED";
export const VOICE_LIST_COMPLETED = "VOICE_LIST_COMPLETED";
export const VOICE_LIST_ERROR = "VOICE_LIST_ERROR";

export const VOICE_ADD_REQUESTED = "VOICE_ADD_REQUESTED";
export const VOICE_ADD_COMPLETED = "VOICE_ADD_COMPLETED";
export const VOICE_ADD_ERROR = "VOICE_ADD_ERROR";

export const VOICE_DELETE_REQUESTED = "VOICE_DELETE_REQUESTED";
export const VOICE_DELETE_COMPLETED = "VOICE_DELETE_COMPLETED";


export const PLAYER_TOGGLE = "PLAYER_TOGGLE"